const whitelabelConfig = {
  lochlomond: {
    brand: 'lochlomond',
    scssVariables: './src/styles/whitelabel-variables/lochlomond',
    brandLogoName: 'lochlomond',
    widgetLogoName: 'lochlomond',
    baseBrandUrl: 'https://nationalparkjourneyplanner.co.uk/', // adding '/' at the end of the url
    mapCenter: {
      lat: 56.11766161403037, // privode value as number and not string
      lng: -4.628756430774287, // privode value as number and not string
    },
  },
  sestran: {
    brand: 'sestran',
    scssVariables: './src/styles/whitelabel-variables/sestran',
    brandLogoName: 'sestran',
    widgetLogoName: 'sestranwidget',
    baseBrandUrl: 'https://gosestran.co.uk/', // adding '/' at the end of the url
    mapCenter: {
      lat: 55.94668781699657, // privode value as number and not string
      lng: -3.2176983688390886, // privode value as number and not string
    },
  },
}

module.exports = whitelabelConfig
